import type { SafetyMeetingLiveAttendanceMeetingSnapshot } from "@miter/types/common";
import { Button } from "ui2";

import { formatMeetingDate, formatTime } from "safety/components/attendance/format";
import { SuccessCheck } from "safety/components/attendance/SuccessCheck";

type ReceiptScreenProps = {
  snapshot: SafetyMeetingLiveAttendanceMeetingSnapshot;
  name: string;
  signedAt: number;
  onAddAnother: () => void;
};

export const ReceiptScreen = ({
  snapshot,
  name,
  signedAt,
  onAddAnother,
}: ReceiptScreenProps): React.JSX.Element => (
  <div className="tw:flex tw:flex-1 tw:flex-col tw:items-center tw:justify-center tw:gap-4 tw:p-6 tw:text-center">
    <SuccessCheck />
    <div>
      <h1 className="tw:m-0 tw:text-2xl tw:font-denim tw:text-midnight">You’re on the list</h1>
      <div className="tw:mt-1 tw:text-sm tw:text-midnight/70">
        {name}, added at {formatTime(signedAt)}.
      </div>
    </div>
    <div className="tw:w-full tw:max-w-90 tw:rounded-md tw:border tw:border-stroke tw:bg-off-white tw:p-4 tw:text-left tw:text-sm">
      <div className="tw:flex tw:justify-between tw:gap-4">
        <span className="tw:text-midnight/50">Meeting</span>
        <span className="tw:font-medium tw:text-midnight">{snapshot.meeting_name}</span>
      </div>
      <div className="tw:mt-2 tw:flex tw:justify-between tw:gap-4">
        <span className="tw:text-midnight/50">When</span>
        <span className="tw:font-medium tw:text-midnight">{formatMeetingDate(snapshot.date)}</span>
      </div>
      {snapshot.job_name && (
        <div className="tw:mt-2 tw:flex tw:justify-between tw:gap-4">
          <span className="tw:text-midnight/50">Where</span>
          <span className="tw:font-medium tw:text-midnight">{snapshot.job_name}</span>
        </div>
      )}
    </div>
    <div className="tw:text-sm tw:text-midnight/60">You can close this page.</div>
    <Button variant="link" onClick={onAddAnother}>
      Add someone else from this phone
    </Button>
  </div>
);
